interface ExportsEmptyStateProps {
  message: string;
}

export function ExportsEmptyState({ message }: ExportsEmptyStateProps) {
  return (
    <div
      data-testid="exports-empty-state"
      className="flex flex-col items-center justify-center py-20 text-center"
    >
      <svg
        className="mb-4 h-12 w-12 text-[var(--color-qup-text-muted-dark)]/40"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.5}
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
        />
      </svg>
      <p className="text-sm text-[var(--color-qup-text-muted-dark)]">{message}</p>
    </div>
  );
}
